<template>
  <DialogWrapper
    closeOnCancel
    ref="exportCandidateAllInfoDialog"
    class="export-candidate-dialog"
    saveBtnLabelI18nKey="common.btn.export"
    :show.sync="show"
    :loading="exportInfo.loading"
    :title="$t(`${i18nPrefix}.title.exportCandidate`)"
    @save="handleSaveClick"
  >
    <el-input
      :placeholder="$t(`common.btn.search`)"
      v-model="filterText">
    </el-input>

    <el-tree
      v-if="show"
      accordion
      show-checkbox
      class="filter-tree"
      ref="fieldTree"
      node-key="col_index"
      :data="exportInfo.data"
      :props="defaultProps"
      :filter-node-method="filterNode"
    ></el-tree>
  </DialogWrapper>
</template>

<script>
import _ from 'lodash'
import DialogWrapper from '../../../../components/dialog/dialogWrapper.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    DialogWrapper
  },
  props: {
    exportInfo: {
      type: Object
    },
    isTalentPool: {
      type: Boolean,
      default: false
    },
    isOperator: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      show: false,
      defaultProps: {
        children: 'children',
        label: 'i18nName'
      },
      filterText: ''
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    ...mapActions('talent', ['getTalentCandidateExportExcelFieldInfo']),
    showDialog () {
      this.show = true
    },
    closeDialog () {
      this.show = false
    },
    filterNode (value, data, note) {
      if (!value) return true
      return note.data.i18nName.indexOf(value) !== -1
    },
    getJobApplicationExportNodes () {
      const checkedNoteList = this.$refs.fieldTree.getCheckedNodes(true, false)
      const selectedNodes = []
      _.forEach(checkedNoteList, note => {
        const selectedNode = {
          col_index: note.col_index,
          data_type: note.data_type,
          cn_header: note.cn_name,
          header: note.en_name
        }
        selectedNodes.push(selectedNode)
      })
      _.forEach(selectedNodes, (note, index) => {
        note.col_index = index
      })
      return selectedNodes
    },
    getCheckedNodes () {
      const checkedNoteList = this.$refs.fieldTree.getCheckedNodes(true, false)
      const selectedNodes = {}
      _.forEach(checkedNoteList, note => {
        if (note.id === 'All') {
          return
        }
        if (!note.children) {
          const selectedNode = selectedNodes[note.parent]
          if (selectedNode) {
            selectedNode.push(note.id)
          } else {
            selectedNodes[note.parent] = [note.id]
          }
        } else {
          selectedNodes[note.id] = [note.id]
        }
      })
      return selectedNodes
    },
    handleSaveClick () {
      if (this.isOperator) {
        this.$emit('saveOperator', this.isTalentPool ? this.getCheckedNodes() : this.getJobApplicationExportNodes(), close => {
          this.loading = false
          if (close) {
            this.closeDialog()
          }
        })
      } else {
        this.$emit('save', this.isTalentPool ? this.getCheckedNodes() : this.getJobApplicationExportNodes(), close => {
          this.loading = false
          if (close) {
            this.closeDialog()
          }
        })
      }
    }
  },
  watch: {
    filterText (val) {
      this.$refs.fieldTree.filter(val)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
